import { DraftConfiguration, ProductType } from '@/types';
import { assertDefined } from '@/utils/assertDefined';
import { getViewId } from '@/model/printArea/getViewId';
import { getView } from '@/model/productType/getView';

export const getViewFromConfiguration = (
  productType: ProductType,
  configuration: DraftConfiguration
) => assertDefined(getView(productType, getViewId(configuration.printArea)));
